import React from "react";
import Bio from "../components/Bio";

const About = () => {
  return (
    <>
      <Bio />
    </>
  );
};

export default About;
